import { render, staticRenderFns } from "./EbookCardSkeleton.vue?vue&type=template&id=7122af80&"
import script from "./EbookCardSkeleton.vue?vue&type=script&lang=js&"
export * from "./EbookCardSkeleton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports